import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { DataSelectBox } from '../../models/selectbox';
import { layDanhMucNhanVien } from '../../services/danhmuc';
import { NhanVienResponse } from '@app/models/nhanvien/NhanVien';
import { maChucVu } from '../../constants';

export const convertDataSelectBox = (data: any, hienThi?: boolean) => {
    let rs: Array<DataSelectBox> = [];
    if (data) {
        rs = data.map((_item: NhanVienResponse) => {
            return {
                value: _item.id,
                label: hienThi ? _item.hoTen : _item.hoTen + " - " + _item.tenChucVu + " - " + _item.tenDonVi
            }
        });
    }
    return rs;
}
const TatCaNhanVienSelectBox = ({ value, nguoiKyNhay, disabled, multiple, allowClear, onChange }: { value?: number | number[], nguoiKyNhay?: boolean, disabled?: boolean, multiple?: boolean, allowClear?: boolean, onChange: (e: any) => void }) => {

    const [data, setData] = useState<Array<DataSelectBox>>([]);
    const layDuLieu = async () => {
        try {
            let rs = await layDanhMucNhanVien();
            if (nguoiKyNhay) {
                let nhanViens = rs.filter((item: any) => item.maChucVu == maChucVu.phoCVP || item.maChucVu == maChucVu.chanhVP);
                setData(convertDataSelectBox(nhanViens, false));
                onChange({
                    target: {
                        value: nhanViens[0].id
                    }
                })
            } else {
                setData(convertDataSelectBox(rs));
            }
        } catch (error: any) {
        };
    }
    useEffect(() => {
        layDuLieu();
    }, []);
    return (
        multiple ?
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn nhân sự--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            disabled={disabled}
            mode= 'multiple'
            allowClear= {allowClear}
            onChange={(e) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
        /> : 
        <Select
            style={{ width: '100%' }}
            showSearch
            placeholder="--Chọn nhân sự--"
            filterOption={function (search, item: any) {
                return item.label.toLowerCase().indexOf(search.toLowerCase()) >= 0 ? true : false
            }}
            value={value}
            options={data}
            disabled={disabled}
            allowClear = {allowClear}
            onChange={(e) => {
                onChange({
                    target: {
                        value: e
                    }
                })
            }}
        />
    );
};

export default TatCaNhanVienSelectBox;
